import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        idModelo: 0,
        idArea: 0,
        destreza: "",
        objetivo: "",
        criterio: "",
    },
    listModelo: [],
    listArea: [],
    results: [],
}

export const modelSearchSlice = createSlice({
    name: "modelSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        setListModelo: (state, action) => {
            state.listModelo = action.payload;
        },
        setListArea: (state, action) => {
            state.listArea = action.payload;
        },
    },
});

export const { setValue, setResults, setListModelo, setListArea } = modelSearchSlice.actions;
export default modelSearchSlice.reducer;
